import { Component } from '@angular/core';
import { AuthenticationService } from '../authentication/authentication/authentication.service';
import { PermissionTypeEnum } from 'src/app/common/permission-enum';
import { QueryParamsService } from 'src/app/services/query-params.service';

@Component({
  selector: 'app-destination',
  templateUrl: './destination.component.html',
  styleUrls: ['./destination.component.scss']
})
export class DestinationComponent {
  permissionType = PermissionTypeEnum;
  tab = 0;

  constructor(
    private authService: AuthenticationService,
    private queryParamsService: QueryParamsService

  ) {
    var permissions = authService.getPermissions();
  }

  ngOnInit(): void {
    this.tab = this.queryParamsService.getNumberParam("tab", 0);
  }

  updateIndexParam(value: any) {
    if (value==this.tab) {
      return;
    }
    this.queryParamsService.setParams({
      tab: value,
    });
  }
}
